import { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { PageHeader, Panel, EmptyState } from "../../components/Bits";
import { api } from "../../lib/api";
import { Megaphone } from "lucide-react";

const PRIORITY_TINT = {
  low: "bg-[#EAE5DE] text-[#5A5652]",
  normal: "bg-[#DCE3D6] text-[#4A5D3E]",
  high: "bg-[#FBEED7] text-[#8C6D31]",
  urgent: "bg-[#F5D8D8] text-[#8C3F3F]",
};

export default function StudentNotices() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/notices").then((r) => setRows(r.data)); }, []);

  return (
    <AppShell>
      <PageHeader overline="From the warden" title="Notice board" subtitle="Announcements and updates from Cozy Heaven." />
      {rows === null ? <div className="text-sm text-warm">Loading…</div>
        : rows.length === 0 ? <Panel><EmptyState title="No notices yet" /></Panel>
          : (
            <div className="grid md:grid-cols-2 gap-4">
              {rows.map((n) => (
                <article key={n.id} className="bg-white border border-warm rounded-lg p-5 card-lift">
                  <div className="flex items-center gap-2">
                    <Megaphone className="h-4 w-4 text-[#A67B5B]" />
                    <span className={`px-2.5 py-0.5 rounded-full text-xs capitalize font-medium ${PRIORITY_TINT[n.priority] || PRIORITY_TINT.normal}`}>{n.priority}</span>
                  </div>
                  <h3 className="font-heading text-2xl text-deep mt-3">{n.title}</h3>
                  <p className="text-warm text-sm mt-2 whitespace-pre-wrap leading-relaxed">{n.content}</p>
                  <div className="mt-4 text-xs text-warm">{new Date(n.created_at).toLocaleString()}</div>
                </article>
              ))}
            </div>
          )}
    </AppShell>
  );
}
